import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "copy"
const CopyIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.79 3H5.684C4.758 3 4 3.736 4 4.636v11.455h1.684V4.636H15.79V3Zm2.526 3.273H9.053c-.927 0-1.685.736-1.685 1.636v11.455c0 .9.758 1.636 1.685 1.636h9.263c.926 0 1.684-.736 1.684-1.636V7.909c0-.9-.758-1.636-1.684-1.636Z" />
    </svg>
  )
}
export default CopyIcon
